<template lang="">
  <div
    class="help-container"
  >
    <ms-popover
      trigger="click"
      placement="bottom"
      :width="popoverSize?.width"
      v-model:visible="visiblePopover"
    >
      <template #reference>
        <div class="flex justify-center items-center">
          <ms-tooltip
            placement="bottom"
            effect="light"
            :hide-after="0"
          >
            <template #content>
              <span>{{ $t('Common.SettingTooltip') }}</span>
            </template>
            <img
              class="help outline-none"
              :src="help.src"
              :width="help.width"
              :height="help.height"
            >
          </ms-tooltip>
        </div>
      </template>
      <template #default>
        <div
          class="option-item"
          v-for="(option, index) in options"
          :key="index"
          @click="option.onClick"
        >
          <img
            :src="option.icon"
            :width="22"
            :height="22"
          >
          <div style="margin-left:10px;cursor: pointer;">
            {{ option.text }}
          </div>
        </div>
      </template>
    </ms-popover>
  </div>
</template>

<script>
import MsTooltip from '@/components/tooltip'
import MsPopover from '@/components/popover'
import BaseList from '../base/base-list.vue'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { mapActions } from 'vuex'
import { sessionStorageKeys } from '@/common/storage-keys.ts'
import { sessionStorage } from '@/utils/storage'
import { UserOption } from '@/utils/cache-data'

const FIRST_LOGIN_GRANTED_ACCOUNT = 'FirstLoginGrantedAccount'

// const FIRST_EMIS_ACCOUNT_LOGIN = 'FirstEMISAcountLogin'

// eslint-disable-next-line no-unused-vars
const suggessAvailableClass = () =>
  import('@/views/pages/teacher/class-room/list/popup-suggest')

export default {
  extends: BaseList,

  components: {
    MsPopover,
    MsTooltip
  },

  data () {
    return {
      help: {
        src: require('@/assets/icons/svg/user_info/ic_Setting_24.svg'),
        width: 24,
        height: 24
      },
      popoverSize: {
        width: 270
      },
      visiblePopover: false,

      UserOptionParams: {
        OptionID: FIRST_LOGIN_GRANTED_ACCOUNT,
        OptionValue: false,
        OptionType: this.$enumeration.OptionType.Boolean,
        IsSystem: false,
        Description: this.$t('ClassRoom.UserOptionListClassroomDescription'),
        UserID: this.userID
      },
      suggessAvailableClass: suggessAvailableClass
    }
  },

  computed: {
    /**
     * check em có là tài khoản trường cung cấp hay không
     */
    isEMIS () {
      return getContextData(ContextDataKey.IsEMIS)
    },

    /**
   * ID của người dùng
   */
    userID () {
      return getContextData(ContextDataKey.UserID)
    },

    // checkRuleUser () {
    //   const me = this
    //   // nếu người dùng là Quản trị ứng dụng
    //   return me.$commonFn.checkRoleUser(me.$enumeration.OrganingCommittee)
    // },

    /**
     * Danh sách các option phần sidebar chi tiết học sinh
     */
    options () {
      const me = this
      let listOptions = [
        {
          iconName: 'ic_Diary_20',
          business: 'ActivityLog',
          event: me.viewDiary
        }
      ]
      if (me.$commonFn.checkRoleUser(me.$enumeration.RoleDictionaryKey.OrganingCommittee)) {
        listOptions.push({
          iconName: 'ic_User_20',
          business: 'LinkSetup',
          event: me.viewLinkSetup
        })
      }
      if (!me.isEMIS) {
        listOptions = listOptions.filter(item => {
          return item.business !== 'EmisStudent'
        })
      }

      return listOptions.map(option => {
        return {
          icon: require(`@/assets/icons/svg/user_info/${option.iconName}.svg`),
          text: me.$t(`User.${option.business}`),
          onClick: option.event
        }
      })
    }

  },

  async mounted () {
    const me = this
    // #region Lưu thông tin useroption lần đầu tài khoản được cấp bên EMIS đăng nhập
    const teacherUsingApp = sessionStorage.get(sessionStorageKeys.TEACHER_USING_APP)

    if (!teacherUsingApp) {
      await me.showSuggestAvaiableClass()
    }
    // #endregion
  },

  methods: {
    ...mapActions('classroom', ['getAvaiableClassrooms']),

    async getOtherPopup (componentName) {
      // eslint-disable-next-line no-eval
      const componentImport = eval(componentName)

      return await componentImport()
    },

    /**
     * @description override base
     */
    getContainer () {
      return this.$refs.container
    },

    /**
     * Hàm ẩn popover thông tin học sinh
     */
    hide () {
      this.visiblePopover = false
    },

    viewDiary () {
      const me = this
      me.$router.push({ path: '/teacher/dashboard/log-activity-teacher' })
      me.hide()
    },

    /**
     * điều hướng tới link setup
     */
    viewLinkSetup () {
      const me = this
      me.$router.push({ path: '/teacher/dashboard/link-setup' })
      me.hide()
    },

    /**
     * @description kiểm tra xem có phải lần đầu đăng nhập hay không, phục phụ show popup gợi ý sử dụng lớp đã tạo sẵn
     * @author NTQuy
     */
    async showSuggestAvaiableClass () {
      const me = this

      // me.UserOptionParams.OptionValue = false
      // await UserOption.SaveUserOption(me.UserOptionParams)

      let firstLogin = await UserOption.GetUserOption(FIRST_LOGIN_GRANTED_ACCOUNT)

      me.UserOptionParams.OptionValue = true
      // me.UserOptionParams.OptionID = FIRST_LOGIN_GRANTED_ACCOUNT
      // Lần đầu đăng nhập chưa có userOption thì thêm mặc định với giá trị true
      if (!firstLogin) {
        firstLogin = await UserOption.SaveUserOption(me.UserOptionParams)
      }

      if (firstLogin === true || firstLogin.OptionValue === true) {
        const container = document.querySelector('#app')

        me.$commonFn.showMask(container)
        me.$router.push('/teacher/classroom')

        if (me.isEMIS) {
          const schoolYear = me.$commonFn.getSchoolYearIndexDB()
          await me.getAvaiableClassrooms(schoolYear).then((res) => {
            // Kiểm tra lớp phù hợp để show gợi ý nếu không có lớp thì update lại keyValue là false
            if (res?.length) {
              me.showDetail(me.suggessAvailableClass)
              me.UserOptionParams.OptionValue = false
              UserOption.SaveUserOption(me.UserOptionParams)
            }
          })
        }
        sessionStorage.set(sessionStorageKeys.TEACHER_USING_APP, true)
        me.$commonFn.hideMask(container)
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.help-container {
  height: 40px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.option-item{
  display: flex;
  cursor: pointer;
  padding: 10px;
}
.ms-popper{
  margin-top: 20px !important;
}
</style>
